<template>
	<div class="banner-split2-about">
		<div class="row-grid">
			<div class="banner">
				<carousel :options="{ interval: 4000, duration: 1000, loop: true }" indicator="inside" control :key="sliderData.length">
					<template v-for="(url, i) in sliderData">
						<img :src="url" width="100%" :key="i">
					</template>
				</carousel>
			</div>
			<div class="scrollable">
				<div class="wrapper">
					<h3 class="title">關於「利澤國際偶戲藝術村」</h3>
					<p class="content">
						零距離的戲偶遊園地<br> 宜蘭老穀倉活化，台灣第一座以當代偶戲為核心特色的藝術園區。融入當代偶劇場領航者–「無獨有偶工作室劇團」近二十年的偶戲創作能量，用心打造成為偶戲創作、藝文互動體驗與展演教育推廣的迷人創意空間，激發無限藝術魅力想像。
						<br>全球嶄新以偶戲發展的藝術創意聚落，是宜蘭重要的文化地景之一。也是台灣的國際偶戲人才孵育基地和創發中心。利澤國際偶戲藝術村包含有：戲偶展示館、專業製偶工廠、藝術家工作室、排練場、展演空間，是亞洲最具規模的當代偶戲創作基地。
						<br>藝術村將透過藝術家駐村創作、偶戲工作坊課程、國際展演交流與教育推廣等常態活動，並進行戲偶主題深度旅遊、穀倉開門相關藝術節慶，帶領台灣大小民眾零距離的領略偶戲美學，並與國際舞台同步接軌，大放異彩。
					</p>
					<h3 class="title">An intimate playground for puppet arts</h3>
					<p class="content">
						A revitalized barn in Yilan now hosts the very first art colony in Taiwan targeting contemporary puppetry. On the basis of Puppet and Its Double’s twenty-year effort in the area, it attempts to establish a fascinating creative space to explore the possibilities of puppetry, to provide interactive art-and-cultural experience, to organize performances and exhibitions, to educate, and so as to inspire everyone with the infinite imagination in the intriguing world of art.
						<br> As a global art colony newly established to popularize puppetry, Lìzé Puppet Art Colony is not merely an important cultural spot in Yilan but also a creative hub and training base for Taiwanese puppet artists to connect to the world. Equipped with the puppet exhibition, a professional puppet building workshop, artists’ studios, rehearsal halls, performance spaces, it is one of the largest multipurpose artistic spaces for contemporary puppetry.
						<br> The regular programs taking place here include artist-in-resident projects, puppetry workshops, masterclasses, collaboration projects, and an international network bringing performances from other countries together, followed by in-depth tours related to the art of puppetry and the Lìzé International Puppet Festival to make puppetry more accessible to Taiwanese of all ages and to make an impressive glocalized presence on the international space.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "bannerSplit2About",
	data() {
		return {
			sliderData: [
				"/static/assets/about/slider/about1.jpg",
				"/static/assets/about/slider/about2.jpg",
				"/static/assets/about/slider/about3.jpg",
			]
		};
	},
	methods: {

	},
	props: {
		ch: String,
		en: String
	},
	components: {
		Carousel: () => import("../Carousel")
	}
};
</script>

<style lang="scss" scoped>
.banner {
	width: 100%;
	@media screen and (min-width: 768px) {
		width: 50%;
	}
	position: relative;

	&::before {
		content: "";
		display: block;
		padding-top: 60%;
	}

	.carousel {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
	}
}
.scrollable {
	flex: 1;
	background: #222222;
	color: #fff;
	line-height: 2;

	.wrapper {
		padding: 30px;
  }

	.title {
		font-size: 1.3em;
		margin: 20px 0;
	}

	@media screen and (min-width: 768px) {
		position: relative;
		overflow-y: auto;

		&::before {
			content: "";
			display: block;
			padding-top: 60%;
		}

		.wrapper {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/banner/banner_split2_about.vue